import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { FullScreen } from 'foundations-components/transitional/components/FullScreen';
import { Lightbox } from 'foundations-components/transitional/components/Lightbox';
import { View } from 'foundations-components/components/View';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Fullscreen({
  fullscreen,
  onClose,
  children
}) {
  const trellisTheme = useTheme();
  if (!fullscreen) return children;
  const contents = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      position: "absolute",
      insetBlockStart: "24px",
      insetInlineEnd: "24px",
      children: /*#__PURE__*/_jsx(CloseButton, {
        color: "fill-tertiary-default",
        onClick: onClose
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: children
    })]
  });

  // if we're NOT in an iframe, we can use a modal
  if (window.self === window.top) return /*#__PURE__*/_jsx(Lightbox, {
    children: contents
  });

  // if we ARE in an iframe, UIModal's transition looks really bad,
  // so we use UIFullScreen instead, with no transition
  return /*#__PURE__*/_jsx(FullScreen, {
    children: /*#__PURE__*/_jsx("div", {
      // focus ourselves, so pressing escape works
      // wait 60ms because of a race condition
      ref: el => {
        setTimeout(() => el === null || el === void 0 ? void 0 : el.focus(), 60);
      },
      style: {
        backgroundImage: `linear-gradient(${trellisTheme === null || trellisTheme === void 0 ? void 0 : trellisTheme.color['icon-core-default']}, ${trellisTheme === null || trellisTheme === void 0 ? void 0 : trellisTheme.color['fill-accent-neutral-default']})`,
        height: '100vh',
        position: 'relative'
      },
      onKeyDown: e => {
        if (e.key === 'Escape') onClose();
      },
      tabIndex: 0,
      children: contents
    })
  });
}